import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const BoardDetail = () => {
  const { category, idx } = useParams();
  const navigate = useNavigate();
  const [detail, setDetail] = useState(null);
  const location = useLocation();
  const { selectedNews } = location.state || {};

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const response = await axios.get(
          `https://www.medicode.co.kr:8445/api/get/${category}/${idx}`
        );
        setDetail(response.data);
      } catch (error) {
        console.error("Error fetching detail data:", error);
      }
    };

    // selectedNews이 없을 경우에만 fetchDetail 호출
    if (!selectedNews) {
      fetchDetail();
    }
  }, [category, idx, selectedNews]);

  if (!detail && !selectedNews) {
    return <div>Loading...</div>;
  }

  const handleDownload = async (img) => {
    try {
      const response = await axios.get(
        `https://www.medicode.co.kr:8445/uploads/${img}`,
        {
          responseType: "blob", // 응답을 Blob으로 설정
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", img); // 다운로드할 파일 이름 설정
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url); // 메모리 해제
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  return (
    <div className="board-detail-wrap">
      <h2>{selectedNews ? selectedNews.title : detail.title}</h2>
      <p className="detail-txt-intro">
        작성자 <span>{selectedNews ? selectedNews.writer : detail.writer}</span>{" "}
        &nbsp;&nbsp;&nbsp;작성일{" "}
        <span>
          {selectedNews
            ? new Date(selectedNews.date).toISOString().split("T")[0]
            : new Date(detail.date).toISOString().split("T")[0]}
        </span>
        &nbsp;&nbsp;&nbsp;조회수:{" "}
        <span>{selectedNews ? selectedNews.hit : detail.hit}</span>
      </p>
      <div className="detail-img-wrap">
        <img
          src={`https://www.medicode.co.kr:8445/uploads/${
            selectedNews ? selectedNews.img1 : detail.img1
          }`}
          alt={selectedNews ? selectedNews.title : detail.title}
        />
      </div>
      <div className="detail-main-txt">
        <p
          dangerouslySetInnerHTML={{
            __html: selectedNews ? selectedNews.content : detail.content,
          }}
        />
      </div>
      <div className="detail-attachment-wrap">
        <p></p>
        {/* {['img1', 'img2', 'img3', 'img4', 'img5'].map((imgKey) => {
          const imgValue = product[imgKey];
          return imgValue ? (
            <button key={imgKey} onClick={() => handleDownload(imgValue)}>
              {imgValue} 다운로드
            </button>
          ) : null;
        })} */}
      </div>
      <div className="detail-list-btn">
        <button onClick={() => navigate(`/board/${category}`)}>목록</button>
      </div>
    </div>
  );
};

export default BoardDetail;
